import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { EntityIdAndPaginationParams } from '../../../shared/models/entity-id-and-pagination-params.model';
import { PaginationDefaults } from '../../../shared/utils/pagination-defaults.util';
import { axiosInstance } from '../../shared/api/axios-instance';
import { createQueryParams } from '../../shared/utils/create-query-params/create-query-params.util';
import { ReleaseDto } from '../dtos/release.dto';
import { ReleaseModel } from '../models/release.model';
import { mapReleaseDtoToReleaseModel } from '../utils/releases-mapping.utils';

export const getAppReleases: AsyncThunk<
  ReleaseModel[],
  Partial<EntityIdAndPaginationParams>,
  Record<number, unknown>
> = createAsyncThunk(
  'app/releases/get',
  async (params: Partial<EntityIdAndPaginationParams>) => {
    const apiPath = `/apps/${params.entityId}/releases`;

    const queryParams = createQueryParams({
      size: params?.pagination?.size
        ? params.pagination.size
        : PaginationDefaults.size,
      offset: params?.pagination?.offset
        ? params.pagination.offset
        : PaginationDefaults.offset,
    });

    const { data }: AxiosResponse<ReleaseDto[]> = await axiosInstance.get(
      apiPath + queryParams
    );

    return data.map(mapReleaseDtoToReleaseModel);
  }
);
